
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/deviceCheck/${viewName}`)
            if (!modules.default.options.metaInfo) {
                modules.default.options.metaInfo = { title }
            }
            resolve(modules)
        }, reject, 'project')
    }
}

let routes = [
    {
        name: 'checkContractList',
        path: '/ems/checkContractList',
        meta: {
            title: '设备点检'
        }
    },
    {
        name: 'checkPlanList',
        path: '/ems/checkPlanList',
        meta: {
            title: '设备点检'
        }
    },
    {
        name: 'systemList',
        path: '/ems/systemList',
        meta: {
            title: '设备点检'
        }
    },
    {
        name: 'systemItemList',
        path: '/ems/systemItemList',
        meta: {
            title: '设备点检'
        }
    },
    {
        name: 'deviceCheckEditor',
        path: '/ems/deviceCheckEditor',
        meta: {
            title: '设备点检'
        }
    },
    {
        name: 'onlineReport',
        path: '/ems/onlineReport',
        meta: {
            title: '在线报告'
        }
    },
    {
        name: 'customerEditor',
        path: '/ems/onlineReport/customerEditor',
        meta: {
            title: '客户信息'
        }
    },
    {
        name: 'logList',
        path: '/ems/onlineReport/logList',
        meta: {
            title: '操作记录'
        }
    },
    {
        name: 'reportMsg',
        path: '/ems/onlineReport/reportMsg',
        meta: {
            title: '报告'
        }
    },
    {
        name: 'reportDownload',
        path: '/ems/onlineReport/reportDownload',
        meta: {
            title: '在线报告'
        }
    },
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/deviceCheck.js